// --- ELEMENTOS DEL DOM ---
// Burger y Menú
const burgerMenu = document.querySelector('.header__burger-btn');
const middleLine = document.querySelector('.header__burger-line.middle');
const bottomLine = document.querySelector('.header__burger-line.bottom');
const underLine = document.querySelector('.bottom-line');
const sideMenuBackground = document.querySelector(".header__side-menu-wrapper");
const sideMenuWrapper = document.querySelector(".header__side-menu-container");
const subscribe = document.querySelector('.header__nav-list > li:nth-child(3)');

const menuElements = [
    burgerMenu,
    sideMenuBackground,
    sideMenuWrapper,
    middleLine,
    bottomLine,
];

const cartButton = document.querySelector('.js-open-cart-btn');
const cartSec = document.querySelector('.cart__section-wrapper');

let closeMenuClearTimeout;

function toggleMenu() {
    if (burgerMenu.classList.contains('active')) {
        closeMenu();
    } else {
        clearTimeout(closeMenuClearTimeout);
        underLine.classList.add('active');
        closeMenuClearTimeout = setTimeout(() => {
            menuElements.forEach(el => el.classList.add('active'));
        }, 150)
    }
}

function closeMenu() {
    if (burgerMenu.classList.contains('active')) {
        clearTimeout(closeMenuClearTimeout);
        menuElements.forEach(el => el.classList.remove('active'));
        
        closeMenuClearTimeout = setTimeout(() => {
            underLine.classList.remove('active');
        }, 200);
    }
}

burgerMenu.addEventListener('click', toggleMenu);


sideMenuBackground.addEventListener('click', closeMenu);
subscribe.addEventListener('click', closeMenu);

burgerMenu.addEventListener('mouseenter', () => {
    if (!burgerMenu.classList.contains("active")) {
        middleLine.classList.add('active');
        bottomLine.classList.add('active');
    }
});

burgerMenu.addEventListener('mouseleave', () => {
    if (!burgerMenu.classList.contains("active")) {
        middleLine.classList.remove('active');
        bottomLine.classList.remove('active');
    }
});

cartButton.addEventListener('click', () => {
    cartButton.classList.toggle('active');
    cartSec.classList.toggle('active');
});